
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const HomePage = lazy(() => import('../pages/home/page'))
const BookingPage = lazy(() => import('../pages/booking/page'))
const AdminPage = lazy(() => import('../pages/admin/page'))
const AdminReviewsPage = lazy(() => import('../pages/admin-reviews/page'))
const BookingDetailsPage = lazy(() => import('../pages/booking-details/page'))
const FeedbackPage = lazy(() => import('../pages/feedback/page'))
const ReviewsPage = lazy(() => import('../pages/reviews/page'))
const NotFoundPage = lazy(() => import('../pages/NotFound'))

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/admin/reviews',
    element: <AdminReviewsPage />
  },
  {
    path: '/secret-admin-panel-2024',
    element: <AdminPage />
  },
  {
    path: '/secret-admin-panel-2024/reviews',
    element: <AdminReviewsPage />
  },
  {
    path: '/booking-details/:id',
    element: <BookingDetailsPage />
  },
  {
    path: '/feedback',
    element: <FeedbackPage />
  },
  {
    path: '/reviews',
    element: <ReviewsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
]

export default routes
